import type { InitData, MappedMenuLink } from '~/plugins/initData'

export type UseInitData = {
  mainMenuLinks: ComputedRef<MappedMenuLink[]>
  footerMenuLinks: ComputedRef<MappedMenuLink[]>
  footerSubmenuLinks: ComputedRef<MappedMenuLink[]>
}

export default function (): UseInitData {
  const data = useState<InitData | null>('initData', () => null)

  return {
    mainMenuLinks: computed(() => data.value?.mainMenuLinks || []),
    footerMenuLinks: computed(() => data.value?.footerMenuLinks || []),
    footerSubmenuLinks: computed(() => data.value?.footerSubmenuLinks || []),
  }
}
